module.exports = __webpack_public_path__ + "media/images/proof_links/colored/medium-d82dea41c450744785b7132cdf938bbe.svg";